import {AddStattedPointDto, StattedPointDto, StattedPointWithSetDto} from "sandy-shared/dist/dtos/statted-point.dto";
import {SetInfoDto} from "sandy-shared/dist/dtos/set.dto";
import {authenticatedFetch} from "../shared/services/http.service";

export const getAllPoints = async (season: string): Promise<StattedPointDto[]> => {
  const result = await authenticatedFetch(
    `${process.env.REACT_APP_SANDY_API_BASE_URL}/api/v1/points?season=${season}`,
    { headers: { 'Content-Type': 'application/json' } },
  ).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch points: ${response.statusText}`);
    }
    return await response.json() as StattedPointDto[]
  });
  return result;
}

export const getPoints = async (season: string, setId: number): Promise<StattedPointDto[]> => {
  const result = await authenticatedFetch(
    `${process.env.REACT_APP_SANDY_API_BASE_URL}/api/v1/points?season=${season}&setId=${setId}`,
    { headers: { 'Content-Type': 'application/json' } },
  ).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch points: ${response.statusText}`);
    }
    return await response.json() as StattedPointDto[]
  });
  return result;
}

export const getPlayerPoints = async (season: string, playerId: number): Promise<StattedPointDto[]> => {
  const result = await authenticatedFetch(
    `${process.env.REACT_APP_SANDY_API_BASE_URL}/api/v1/points?season=${season}&playerId=${playerId}`,
    { headers: { 'Content-Type': 'application/json' } },
  ).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to fetch points: ${response.statusText}`);
    }
    return await response.json() as StattedPointDto[]
  });
  return result;
}

export async function savePoint(point: AddStattedPointDto): Promise<StattedPointWithSetDto> {
  const result = await authenticatedFetch(
    `${process.env.REACT_APP_SANDY_API_BASE_URL}/api/v1/points`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(point),
    },
  ).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to add point: ${response.statusText}`);
    }
    return await response.json() as StattedPointWithSetDto
  });;
  return result;
}

export const deletePoint = async (pointId: number): Promise<void> => {
  await authenticatedFetch(
    `${process.env.REACT_APP_SANDY_API_BASE_URL}/api/v1/points/${pointId}`,
    { method: 'DELETE', headers: { 'Content-Type': 'application/json' } },
  ).then(async response => {
    if (!response.ok) {
      throw new Error(`Failed to delete point: ${response.statusText}`);
    }
  });
}